import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Loadable from '@/components/common/loadable';
import { getTickets } from '@/store/actions/ticket';
import { PAGINATION_DEFAULT } from '@/common/constant';
import { getDate } from '@/common/utils';
import HeadingCenter from '@/components/common/heading-center';
import { ticketListPage } from '@/components/common/heading-center/breadcrumb-config';
import './style.scss';
import { statusFilterOptions } from '../../base-table/table-settings';
import Search from '@/components/common/search-center';

const BaseTable = Loadable({
  loader: () => import('@/components/base-table'),
});

const keyName = 'ticket';

const TicketList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const stateTicket = useSelector((state) => state.ticket);
  const [data, setData] = useState([]);
  const [queryData, setQuery] = useState(PAGINATION_DEFAULT);
  const { list: ticketList, isLoading } = stateTicket;
  const stateAuthenticate = useSelector((state) => state.authenticate);
  const staff_id = get(stateAuthenticate, ['user', 'staff_id']);
  const email = get(stateAuthenticate, ['user', 'email']);

  /**
   * Call APi get categories with params
   * @param {*} params
   */
  const getTicketsFunc = (params) => {
    const queryParams = { ...queryData, ...params, staff_id, email };
    dispatch(getTickets(queryParams));
    setQuery(queryParams);
  };

  useEffect(() => {
    getTicketsFunc({
      limit: 10,
      page: 1,
      status: statusFilterOptions[1].value,
      search: '',
    });
  }, []);

  useEffect(() => {
    setData(ticketList.data);
  }, [ticketList]);

  /**
   * clear value for function search
   */
  const clearSearch = () => {
    const query = { ...queryData, search: '' };
    setQuery(query);
    getTicketsFunc(query);
  };

  /**
   * Search ticket by name
   * @param search
   */
  const onSearch = (search = '') => {
    const query = { ...queryData, search };
    if (!search) clearSearch();
    getTicketsFunc(query);
  };

  /**
   * The function run when the table change inside and callback to this function
   * @param {*} param0
   */
  const onTableChangeFunc = ({ sortQuery }) => {
    getTicketsFunc({
      sort_item: sortQuery.sort_order && sortQuery.sort_column,
      sort_by: sortQuery.sort_order,
    });
  };

  /**
   * The function check keys in row to expand row
   * @returns
   * @param item
   */
  const onRow = (item) => ({
    onClick: () => {
      history.push(`ticket/${item.ticket_id}`);
    },
  });

  const getSortDirection = (field) => {
    return queryData.sort_item === field
      ? queryData.sort_by === 'asc'
        ? 'ascend'
        : 'descend'
      : undefined;
  };

  const columns = [
    {
      title: 'Ticket',
      dataIndex: 'number',
      align: 'center',
      width: 110,
      sorter: true,
      sortOrder: getSortDirection('number'),
      render: (val, item) => (
        <div className={`${item.isoverdue ? 'ticket-tag-overdue' : 'ticket-tag'}`}>{val}</div>
      ),
    },
    {
      title: 'Created',
      dataIndex: 'created',
      align: 'left',
      width: 110,
      sorter: true,
      sortOrder: getSortDirection('created'),
      render: (val) => getDate(val, 'DD/MM/YYYY'),
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      align: 'left',
      sorter: true,
      width: '60%',
      sortOrder: getSortDirection('subject'),
    },
    {
      title: 'Status',
      dataIndex: 'status_id',
      align: 'center',
      width: 110,
      sorter: true,
      sortOrder: getSortDirection('status_id'),
      render: (val, record) => record.status?.name || '',
    },
    {
      title: 'Resolved',
      dataIndex: 'closed',
      align: 'left',
      sorter: true,
      width: 110,
      sortOrder: getSortDirection('closed'),
      render: (val) => getDate(val, 'DD/MM/YYYY'),
    },
  ];

  return (
    <>
      <HeadingCenter pageConfig={ticketListPage} />
      <Search onSearch={onSearch} onClearSearch={clearSearch} />
      <div className="ticket-list">
        <BaseTable
          rowKey="ticket_id"
          onRow={onRow}
          tableName={keyName}
          columns={columns}
          data={[...data]}
          metadata={queryData}
          total={ticketList?.metadata?.total || 0}
          isLoading={isLoading}
          onChangePageProps={getTicketsFunc}
          onTableChangeFunc={onTableChangeFunc}
          isExpandProp={false}
        />
      </div>
    </>
  );
};

export default TicketList;
